var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
var MyModel = /** @class */ (function (_super) {
    __extends(MyModel, _super);
    function MyModel(root) {
        return _super.call(this, "/api/", root, {}) || this;
    }
    return MyModel;
}(KnockoutModel));
var MyPage = /** @class */ (function (_super) {
    __extends(MyPage, _super);
    function MyPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyPage.prototype.init = function () {
        this.c = new MyModel(this.container);
    };
    MyPage.prototype.update = function (arg) {
        //return this.c.loadData()
        return Promise.resolve();
    };
    return MyPage;
}(Page));
export default MyPage;
